const __WEBPACK_NAMESPACE_OBJECT__ = require("@mui/icons-material/PaymentsOutlined");